import modalActions from "actions/modal";
import cn from "classnames";
import { Transition } from "components/shared/column";
import { dateTimeToView } from "helpers/date";
import { paths } from "helpers/paths";
import { useRouter } from "hooks/useRouter";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { deleteOdometerHistoryItem, getOdometerHistoryItems } from "sources/admin/odometers";
import EditForm from "./editForm";

function OdometerHistory({ history, modal }) {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState();
    const { query } = useRouter();

    const refreshData = () => {
        setLoading(true);
        getOdometerHistoryItems(query.id).then((res) => {
            setData(res);
            setLoading(false);
        });
    };

    useEffect(() => {
        refreshData();
    }, []);

    const handleEdit = (item) => {
        modal({
            name: "default",
            title: "Редактирование",
            CustomBody: EditForm,
            bodyData: { organizationId: query.id, refreshData, data: item },
        });
    };

    const handleDelete = (id) => {
        setLoading(true);
        modal({
            name: "confirm",
            title: "Удаление",
            text: "Вы уверены, что хотите удалить?",
            buttons: { confirm: "Удалить", cancel: "Отменить" },
            action: () => deleteOdometerHistoryItem({ id, organizationId: query.id }).then(() => refreshData()),
        });
    };

    return (
        <div className="page-content">
            <Transition dir="full">
                <div className="page-book__list book-list list book-list--nofilter">
                    <div className="book-list__head-wrap">
                        <div className="book-list__head">
                            <div
                                className="book-list__head-close close close--sm"
                                onClick={() => history.push(paths.adminOrganizationsShow(query.id))}
                            />
                            <div className="book-list__head-title">История редактирования одометра</div>
                        </div>
                    </div>
                    <div className="list__body-wrap">
                        <div className={cn("list__body d-flex flex-column", { loading })}>
                            <div className="container">
                                {data?.length === 0 ? (
                                    <div className="text-center py-4">Нет данных</div>
                                ) : (
                                    <table className="table table-sm">
                                        <thead>
                                            <tr>
                                                <th />
                                                <th>ID</th>
                                                <th>Начало</th>
                                                <th>Конец</th>
                                                <th />
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data?.map((item, index) => (
                                                <tr key={item.id}>
                                                    <td>{index + 1}</td>
                                                    <td>{item.id}</td>
                                                    <td>{dateTimeToView(item.startedAt)}</td>
                                                    <td>{dateTimeToView(item.endedAt)}</td>
                                                    <td>
                                                        <button
                                                            className="btn btn-xs btn-outline-primary mr-2"
                                                            onClick={() => handleEdit(item)}
                                                        >
                                                            Редактировать
                                                        </button>
                                                        <button
                                                            className="btn btn-xs btn-danger"
                                                            onClick={() => handleDelete(item.id)}
                                                        >
                                                            Удалить
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Transition>
        </div>
    );
}

export default connect(
    (_state) => ({}),
    (dispatch) => ({
        modal: (params) => dispatch(modalActions.open(params)),
    }),
)(OdometerHistory);
